export default "__VITE_ASSET__9fe4a656__"